import React, {useState} from 'react';
import { useOrderContext } from './OrderContext';
import {SuccessOrder} from './business/Order';
import { CalculateModal } from './template/CalculateModal';
import { RecipeModal } from './template/RecipeModal';

function OrderItem() {
    const {setCancelData, setOrders, orders} = useOrderContext();

    const [quantity, setQuantity] = useState({});
    const [recipe, setRecipe] = useState({});

    const handleCalculateBtn = (data) => {
        setQuantity({orderId: data.orderId, dishId: data.dishId, quantity: data.quantity})
    }

    const handleSuccessOrder = (data) => {
        SuccessOrder(orders, setOrders, data)
    }

    return (
        <>
            { Object.entries(orders).map(([orderId, order]) => {

                return (
                    <div className="col-12" key={orderId}>
                        <div className="row">
                            <div className="card text-bg-secondary mb-2">
                            <div className="card-header">Замовлення № {orderId}</div>
                            <div className="card-body">
                                <div className="card-text">Офіціант: {order.author}</div>
                                <div className="card-text">Зал: {order.hall}</div>
                                <div className="card-text">Стіл: {order.tabl}</div>
                                {'note' in order && order.note !== null && (
                                    <div className="card-text">Примітка до замовлення: {order.note}</div>
                                )}
                                <div className="row d-flex align-items-stretch">
                                {Object.entries(order).flatMap(([dishId, item]) => {
                                    if (typeof item === 'object' && item !== null) {
                                        return (
                                            <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-2" key={dishId}>
                                                <div className="card text-bg-warning">
                                                    <div className="card-header"></div>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-6">Страва:</div>
                                                            <div className="col-6">{item.menu_name}</div>
                                                        </div>
                                                        {item.weight === null ? (
                                                                <div className="row">
                                                                    <div className="col-6">Кількість:</div>
                                                                    <div className="col-6">{item.qty}</div>
                                                                </div>
                                                            ) : (
                                                                <div className="row">
                                                                    <div className="col-6">Кількість:</div>
                                                                    <div className="col-6">
                                                                        {item.qty} 
                                                                        <span className='open-calc' onClick={() => handleCalculateBtn({orderId, dishId, quantity: item.qty})} data-bs-toggle="modal" data-bs-target="#calculateModal" >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" id="edit" width="20" height="20">
                                                                                <path d="M3.5,24h15A3.51,3.51,0,0,0,22,20.487V12.95a1,1,0,0,0-2,0v7.537A1.508,1.508,0,0,1,18.5,22H3.5A1.508,1.508,0,0,1,2,20.487V5.513A1.508,1.508,0,0,1,3.5,4H11a1,1,0,0,0,0-2H3.5A3.51,3.51,0,0,0,0,5.513V20.487A3.51,3.51,0,0,0,3.5,24Z"></path><path d="M9.455,10.544l-.789,3.614a1,1,0,0,0,.271.921,1.038,1.038,0,0,0,.92.269l3.606-.791a1,1,0,0,0,.494-.271l9.114-9.114a3,3,0,0,0,0-4.243,3.07,3.07,0,0,0-4.242,0l-9.1,9.123A1,1,0,0,0,9.455,10.544Zm10.788-8.2a1.022,1.022,0,0,1,1.414,0,1.009,1.009,0,0,1,0,1.413l-.707.707L19.536,3.05Zm-8.9,8.914,6.774-6.791,1.4,1.407-6.777,6.793-1.795.394Z"></path>
                                                                            </svg>
                                                                        </span> 
                                                                    </div>
                                                                </div>
                                                            )}
                                                        {'comment' in item && item.comment !== null && (
                                                            <div className="row">
                                                                <div className="row">
                                                                    <div className="col">Коментар:</div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col">{item.comment}</div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        
                                                        <div className="row mt-3 ">
                                                            
                                                        </div>
                                                    </div>
                                                    <div class="card-footer d-flex justify-content-between">
                                                        <div className="col-4">
                                                            <button type="button" onClick={() => handleSuccessOrder([orderId, dishId])} className="btn btn-dark text-uppercase">Готово</button>
                                                        </div>
                                                        {'recipe' in item && item.recipe !== null && item.recipe.length !== 0 && (
                                                                <div className="col-4 d-flex justify-content-center">
                                                                    <button type="button" onClick={() => setRecipe(item.recipe)}  className="btn btn-dark text-uppercase" data-bs-toggle="modal" data-bs-target="#exampleModal">
                                                                        Рецепт
                                                                    </button>
                                                                </div>
                                                            )
                                                        }
                                                        <div className="col-4 d-flex justify-content-end">
                                                            <button type="button" data-bs-toggle="modal" data-bs-target="#cancelOrder" onClick={() => setCancelData([orderId, dishId]) } className="btn btn-dark text-uppercase">Відміна</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }
                                    return null;
                                })}

                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                )
            })}
            <RecipeModal data={recipe}/>
            <CalculateModal data={quantity}/>
        </>
    );
}
export default OrderItem;